// extracted by mini-css-extract-plugin
module.exports = {"panePlate":"PanePlate__panePlate__F0Mcm"};